import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./career-with-us.component').then(m => m.CareerWithUsComponent),
        data: {
          title: 'KudosHub | Career With Us',
          description:'Working with us offers so much more than just a ‘job.’ If you are someone who loves to take on challenges to learn and grow, we are looking for you.',
          keywords: 'email validation service, livechat & customer support, email marketing, web design & development, mobile applications',
          gTitle: 'KudosHub | Career With Us',
          ogDesc: 'Working with us offers so much more than just a ‘job.’ We invite you to explore your career path with us. Learn more about the current openings.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/career-with-us.webp',
          ogUrl: 'https://kudoshub.com/career-with-us',
          twitterTitle: 'KudosHub | Career With Us',
          twitterDesc: 'Working with us offers so much more than just a ‘job.’ We invite you to explore your career path with us. Learn more about the current openings.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/career-with-us.webp'
        }
      }
    ]
  }
];
